import { DeepMap } from 'react-hook-form';
import { SelectOptionElement } from '@odin-labs/components';
import { JobsiteUpdateInput } from 'apollo/generated/client-operations';
import { ensureNonUndefinedFields } from 'utils';
import { FormInputTypes, TypedFormInputs } from 'components/form';
import { EditJobsiteConfigurationFormData } from 'containers/jobsiteConfiguration/types';
import { getSessionDisplayColumnOptions } from 'containers/jobsites/helpers/utils';
import { Jobsite } from './types';
import {
  getSiteAccessRulesSectionDefaultValues,
  getSiteAccessRulesSectionInputs,
  getSiteAccessRulesSectionUpdateInput,
} from './siteAccessRulesSection';

export type EditJobsiteConfigTabFormData = Pick<
  EditJobsiteConfigurationFormData,
  'siteAccessRules'
>;

export type JobsiteSelectOptions = {
  sessionDisplayColumnOptions: SelectOptionElement[];
};

export const getDropdownsOptions = (): JobsiteSelectOptions => {
  return {
    sessionDisplayColumnOptions: getSessionDisplayColumnOptions(),
  };
};

type GetFormInputsArgs = JobsiteSelectOptions;

export const getFormInputs = (
  args: GetFormInputsArgs,
): TypedFormInputs<EditJobsiteConfigTabFormData> => {
  const { sessionDisplayColumnOptions } = args;

  const siteAccessRulesSectionInputs = getSiteAccessRulesSectionInputs({
    sessionDisplayColumnOptions,
  });

  return {
    siteAccessRules: {
      element: FormInputTypes.Section,
      layout: '',
      elementProps: {
        title: 'Site Access Rules',
      },
      children: siteAccessRulesSectionInputs,
    },
  };
};

type GetDefaultValuesArgs = {
  jobsite: Jobsite;
} & JobsiteSelectOptions;

export const getDefaultValues = (
  args: GetDefaultValuesArgs,
): EditJobsiteConfigTabFormData => {
  const { jobsite, sessionDisplayColumnOptions } = args;

  const siteAccessRules = getSiteAccessRulesSectionDefaultValues(
    jobsite,
    sessionDisplayColumnOptions,
  );

  return { siteAccessRules };
};

export const getJobsiteUpdateInput = (
  jobsite: Jobsite,
  data: EditJobsiteConfigTabFormData,
  dirtyFields: DeepMap<EditJobsiteConfigTabFormData, true>,
): JobsiteUpdateInput => {
  return ensureNonUndefinedFields<JobsiteUpdateInput>({
    jobsiteId: jobsite.jobsiteId,
    ...getSiteAccessRulesSectionUpdateInput(
      data.siteAccessRules,
      dirtyFields.siteAccessRules,
    ),
  });
};
